import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const StyledLink = styled(Link)`
  color: #e2f1ff;
  text-decoration: none;
  &:hover {
    color: grey;
  }
`